module.exports = __webpack_public_path__ + "img/no_baby_record.1451bf2f.png";